module.exports = __webpack_public_path__ + "img/gite-5-1.cd6d50a0.jpg";